"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftTime = void 0;
exports.instanceOfShiftTime = instanceOfShiftTime;
exports.ShiftTimeFromJSON = ShiftTimeFromJSON;
exports.ShiftTimeFromJSONTyped = ShiftTimeFromJSONTyped;
exports.ShiftTimeToJSON = ShiftTimeToJSON;
exports.ShiftTimeToJSONTyped = ShiftTimeToJSONTyped;
/**
 *
 * @export
 */
exports.ShiftTime = {
    Days06001830: 'DAYS_0600_1830',
    Days07001100: 'DAYS_0700_1100',
    Days07001530: 'DAYS_0700_1530',
    Days07001930: 'DAYS_0700_1930',
    Days11001500: 'DAYS_1100_1500',
    Eves15001900: 'EVES_1500_1900',
    Eves15002330: 'EVES_1500_2330',
    Eves19002300: 'EVES_1900_2300',
    Nights03000700: 'NIGHTS_0300_0700',
    Nights18000630: 'NIGHTS_1800_0630',
    Nights19000730: 'NIGHTS_1900_0730',
    Nights23000300: 'NIGHTS_2300_0300',
    Nights23000730: 'NIGHTS_2300_0730',
    Custom: 'CUSTOM'
};
function instanceOfShiftTime(value) {
    for (const key in exports.ShiftTime) {
        if (Object.prototype.hasOwnProperty.call(exports.ShiftTime, key)) {
            if (exports.ShiftTime[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function ShiftTimeFromJSON(json) {
    return ShiftTimeFromJSONTyped(json, false);
}
function ShiftTimeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShiftTimeToJSON(value) {
    return value;
}
function ShiftTimeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=ShiftTime.js.map